module.exports = __webpack_public_path__ + "static/emblica-b382d6bdbdb47dbae8b37e994fadafc0.svg";